import { createReducer, on } from "@ngrx/store";
import { UsersState } from "../../models/users-state.model";
import * as usersActions from "../actions/users.action";

export const initialUsersState: UsersState = {
  users: [],
  user: null,
  isLoading: false,
  error: null,
  page: 1,
  totalItems: 0,
  totalPages: 0,
  selectedUserId: null,
  selectedUser: null,
};

export const usersReducer = createReducer(
  initialUsersState,
  on(usersActions.loadUsers, (state) => {
    console.log("loadUsers action dispatched");
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(usersActions.loadUsersSuccess, (state, action) => ({
    ...state,
    users: action.users.items,
    totalItems: action.users.total_items,
    totalPages: action.users.total_pages,
    isLoading: false,
  })),
  on(usersActions.loadUsersFailure, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  })),
  on(usersActions.updatedUser, (state, action) => ({
    ...state,
    user: action.user,
  })),
    on(usersActions.createUser, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(usersActions.createUserSuccess, (state, action) => ({
        ...state,
        users: [...state.users, action.user],
        isLoading: false,
    })),
    on(usersActions.createUserFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(usersActions.editUser, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(usersActions.editUserSuccess, (state, action) => ({
        ...state,
        users: state.users.map(user => user.id === action.user.id ? action.user : user),
        isLoading: false,
    })),
    on(usersActions.editUserFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(usersActions.deleteUser, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(usersActions.deleteUserSuccess, (state, action) => ({
        ...state,
        users: state.users.filter(user => user.id !== action.id),
        isLoading: false,
    })),
    on(usersActions.deleteUserFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(usersActions.loadUserById, (state, action) => ({
        ...state,
       isLoading: true,
    })),
    on(usersActions.loadUserByIdSuccess, (state, action) => ({
        ...state,
        user: action.user,
        isLoading: false,
    })),
    on(usersActions.loadUserByIdFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
);